import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AuiIcon, SRow, SCol } from '@avalara/skylab-sdk/react';
import { selectState } from '../../../selectors';
import Resources from '../../shared/resources';
import Banner from '../../styled/components/single-column-banner';
import { BlackText } from '../../styled/components/thank-you';
import MiddleContent from './middle-content';
import AvalaraForShopifyThankyou from './avalara-for-shopify';
import FreeTrialThankYou from './free-trial';
const ThankYou = () => {
    const { account: { isLoggedIn, primaryContactEmail }, offer: { isFreeTrial, offerName, thankYouContent: { customHeadingText, resourceHeading, resourceContent, topTextContent, icon, }, }, sharedSignup: { signupForm: { email } }, } = useSelector(selectState);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    if (offerName === 'Avalara for Shopify') {
        return React.createElement(AvalaraForShopifyThankyou, null);
    }
    if (offerName === 'Free Trial') {
        return React.createElement(FreeTrialThankYou, null);
    }
    const getTopTextContent = (text) => {
        const emailForCommunication = isLoggedIn ? primaryContactEmail : email;
        return text.replace('[EMAIL]', emailForCommunication);
    };
    const actionText = isFreeTrial ? 'starting your free trial of' : 'purchasing';
    const getHeaderContent = () => {
        if (customHeadingText) {
            return React.createElement("div", { className: 'flex justify-content-center' },
                React.createElement("h1", { className: 'pad-all-md text-center', "data-ref": 'offer.custom-thank-you-heading' }, customHeadingText));
        }
        if (icon) {
            return React.createElement(AuiIcon, { name: icon, alt: 'thank you icon' });
        }
        return React.createElement(Banner, { orange: true, className: 'pad-all-lg flex align-items-center' },
            React.createElement("h1", { className: 'text-center text-xxl font-normal text-white', "data-ref": 'offer.thank-you-heading' },
                "Thank you for ",
                actionText,
                " ",
                offerName));
    };
    const resourceSectionHeading = resourceHeading || 'In the meantime, discover other compliance tools';
    const hideContent = offerName === 'Avalara Sales Tax Registration' && isLoggedIn;
    return (React.createElement(SRow, null,
        React.createElement(SCol, { span: '12' },
            getHeaderContent(),
            topTextContent && topTextContent.length > 0 &&
                React.createElement("div", { className: 'flex flex-dir-col align-items-center text-center', "data-ref": 'offer.thank-you.top-text-content' }, topTextContent.map((text, i) => (React.createElement("h2", { key: `topContent${i}`, className: 'pad-bottom-md text-center' }, getTopTextContent(text))))),
            !hideContent && React.createElement(MiddleContent, null),
            !hideContent && resourceContent && resourceContent.length > 0 &&
                React.createElement(BlackText, { role: 'main' },
                    React.createElement("div", { className: 'flex flex-dir-col align-items-center pad-left-sm pad-right-sm', "data-ref": 'offer.thank-you.resource-content' },
                        React.createElement("h2", { className: 'text-center pad-top-lg pad-bottom-none' }, resourceSectionHeading),
                        React.createElement(Resources, { content: resourceContent }))))));
};
export default ThankYou;
